import repository from '@/utils/repository';

const common_resource = '/move';

export default {
    searchOfficeInfo: (data) => {
        return repository.post(`${common_resource}/postCommonOfficeInfo`, {
            ...data
        });
    }
};
